import type { IPointOfInterest } from '@/types';
import { PLACE_SITE_TYPES } from '../constants/placeSiteTypes';
import type { PointOfInterestPlace } from './pointOfInterest';

/** The create payload for a basemap place. `type` is the icon name the map painted. */
export function placeToPointOfInterest(place: PointOfInterestPlace): Omit<IPointOfInterest, 'id'> {
  return {
    name: place.name,
    type: place.maki,
    latitude: place.latitude,
    longitude: place.longitude,
  };
}

/** Icons that used to share the parking chip. They stay motorist on a stored pin. */
const PIN_CLASS_BY_MAKI: Record<string, string> = {
  parking: 'motorist',
  'parking-garage': 'motorist',
};

function placeClassFor(maki: string): string {
  const fromChip = PLACE_SITE_TYPES.find((siteType) =>
    (siteType.makis as readonly string[]).includes(maki),
  )?.placeClass;
  if (fromChip) return fromChip;
  return PIN_CLASS_BY_MAKI[maki] ?? '';
}

/** The pin for a stored place. The server keeps the icon name, not the basemap category, so the
 * category comes back from the site-type table; a place outside it keeps the neutral colour. */
export function pointOfInterestPlace(
  place: Pick<IPointOfInterest, 'name' | 'type' | 'latitude' | 'longitude'>,
): PointOfInterestPlace {
  return {
    name: place.name,
    longitude: place.longitude,
    latitude: place.latitude,
    maki: place.type,
    placeClass: placeClassFor(place.type),
  };
}
